import { useState } from "react";
import type { ReactNode } from "react";
import { useSearchParams } from "react-router-dom";

import CloudIcon from "@mui/icons-material/Cloud";
import ViewContent from "../../../components/ViewContent";

import { Alert, AlertTitle } from "@mui/material";

import useDataGridFilterStore from "../../../stores/dataGridFilter";
import OrganizationCloudTab from "../Organization/tabs/cloud";

const CloudListFolder = () => {
  const [searchParams] = useSearchParams();
  const error = useDataGridFilterStore((state) => state.error);
  const id = searchParams.get("id");
  const path = searchParams.get("path");
  const [toolbarButton, setToolbarButton] = useState<ReactNode>(null);

  if (error) {
    return (
      <Alert severity="error" sx={{ mt: 1 }}>
        <AlertTitle>Ops!</AlertTitle>
        Um erro inesperado ocorreu. Tente novamente mais tarde.
      </Alert>
    );
  }

  return (
    <ViewContent
      title="Cloud"
      icon={<CloudIcon sx={{ mr: 2 }} />}
      button={toolbarButton}
    >
      <OrganizationCloudTab
        id={id || undefined}
        path={path || undefined}
        boxPadding={0}
        onToolbarButtonChange={setToolbarButton}
      />
    </ViewContent>
  );
};

export default CloudListFolder;
